<template>
  <v-layout row justify-center>
    <v-dialog v-model="isVisible" fullscreen hide-overlay transition="dialog-bottom-transition">
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon @click.native="isVisible = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>User settings</v-toolbar-title>
        </v-toolbar>
        <v-card-actions>
          <v-container>
            <reset-user-password></reset-user-password>

            <v-divider></v-divider>
            <v-subheader>User sms templates</v-subheader>
            <v-checkbox
              @change="SaveIsCompanyTemplateUsed"
              v-model="useCompanysSMSTemplates"
              label="Use company templates"
            ></v-checkbox>
            <v-row justify="space-around" v-if="!useCompanysSMSTemplates">
              <div v-for="(smstemplate, index) in smsTemplates" :key="index">
                <company-settings-card>
                  <template #title>{{ smstemplate.title }}</template>
                  <template #save>
                    <v-btn
                      :disabled="
                        !$v.smsTemplates.$each[index].text.$dirty ||
                          $v.smsTemplates.$each[index].text.$model === ''
                      "
                      color="white"
                      @click="SaveSmsTemplate($v.smsTemplates.$each[index])"
                    >
                      <v-icon color="primary">mdi-content-save</v-icon>
                    </v-btn>
                  </template>
                  <template #templateText>
                    <v-textarea
                      outlined
                      background-color="white"
                      light
                      name="input-7-4"
                      v-model="$v.smsTemplates.$each[index].text.$model"
                      no-resize
                      :maxlength="smsCharLength"
                      :counter="smsCharLength"
                      @input="$v.smsTemplates.$each[index].text.$touch()"
                      :ref="smstemplate.type"
                    ></v-textarea>
                  </template>
                  <template #cardActions>
                    <v-btn
                      light
                      class="mb-3"
                      color="white"
                      @click="Insert(' {{USER}}', $v.smsTemplates.$each[index])"
                      >Name</v-btn
                    >
                    <v-btn
                      light
                      color="white"
                      @click="Insert(' {{STARTDATETIME}}', $v.smsTemplates.$each[index])"
                      >Date & time</v-btn
                    >
                  </template>
                  <template></template>
                </company-settings-card>
              </div>
            </v-row>
          </v-container>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import companySettingsCard from '../main/CompanySettingsCard.vue';
import { required } from 'vuelidate/lib/validators';
import axios from 'axios';
import ResetUserPassword from '../main/user/ResetUserPassword.vue';

export default {
  components: {
    companySettingsCard,
    ResetUserPassword,
  },
  validations: {
    smsTemplates: {
      $each: {
        text: { required },
      },
    },
  },
  data() {
    return {
      isVisible: false,
      smsCharLength: 140,
      useCompanysSMSTemplates: true,
      smsTemplates: [
        {
          type: 'smstemplate',
          title: 'Registration template - primary language',
          text: '',
          errors: [],
        },
        {
          type: 'smstemplate-secondary',
          title: 'Registration template - secondary language',
          text: '',
          errors: [],
        },
        {
          type: 'updatetemplate',
          title: 'Update template - primary language',
          text: '',
          errors: [],
        },
        {
          type: 'updatetemplate-secondary',
          title: 'Update template - secondary language',
          text: '',
          errors: [],
        },
        {
          type: 'smstemplate-reminder',
          title: 'Reminder template - primary language',
          text: '',
          errors: [],
        },
        {
          type: 'smstemplate-reminder-secondary',
          title: 'Reminder template - secondary language',
          text: '',
          errors: [],
        },
      ],
    };
  },
  computed: {},

  methods: {
    OpenDialog() {
      this.isVisible = true;
      this.GetUserConfigs();
    },
    CloseDialog() {
      this.isVisible = false;
    },
    Insert(myvalue, template) {
      let control = this.$refs[template.$model.type][0].$el.querySelector('textarea');

      let controlTextValue = control.value;
      let cursorPos = control.selectionEnd;
      if (controlTextValue == null || controlTextValue === '') {
        controlTextValue = myvalue;
        return;
      }
      controlTextValue =
        controlTextValue.substring(0, cursorPos) + myvalue + controlTextValue.substring(cursorPos);
      cursorPos += controlTextValue.length;
      template.text.$model = controlTextValue;
    },
    SaveIsCompanyTemplateUsed() {
      let userId = this.$store.getters.user.details.id;
      var userConfig = {
        userConfig: {
          userId: userId,
          configKey: 'UseCompanySMSTemplates',
          configValue: this.useCompanysSMSTemplates.toString(),
        },
      };

      let mutation = ` mutation saveuserconfig($userConfig: SaveUserConfig!) {
	      saveuserconfig(userConfig: $userConfig) {
          id
          }
        }`;
      axios
        .post('/graphql', {
          query: mutation,
          variables: userConfig,
        })
        .then((res) => {
          if (res.data.data.saveuserconfig) {
            this.showSuccess('Setting saved!');
          }
        })
        .then(() => {
          this.GetUserConfigs();
        })
        .catch(() => {
          this.showError('Could not save the setting');
        });
    },
    GetUserConfigs() {
      let queryString = `query userConfigs($id: String!){
          userConfigs(id:$id) {
            configKey
            configValue
          }
        }`;

      axios
        .post('/graphql', {
          query: queryString,
          variables: { id: this.$store.getters.user.details.id },
        })
        .then((res) => {
          let configs = res.data.data.userConfigs;
          configs.forEach((config) => {
            if (config && config.configKey) {
              if (
                config.configKey === 'smstemplate' ||
                config.configKey === 'smstemplate-secondary' ||
                config.configKey === 'updatetemplate' ||
                config.configKey === 'updatetemplate-secondary' ||
                config.configKey === 'smstemplate-reminder' ||
                config.configKey === 'smstemplate-reminder-secondary'
              ) {
                this.smsTemplates.find((conf) => conf.type == config.configKey).text =
                  config.configValue;
              }

              if (config.configKey === 'UseCompanySMSTemplates') {
                this.useCompanysSMSTemplates = config.configValue === 'true';
              }
            }
          });
        })
        .catch(() => {
          this.showError('Error occured while getting the user settings');
        });
    },

    SaveSmsTemplate(smstemplate) {
      smstemplate.text.$touch();
      if (smstemplate.text.$invalid) return;
      let type = smstemplate.$model.type;
      let userId = this.$store.getters.user.details.id;
      var userConfig = {
        userConfig: {
          userId: userId,
          configKey: type,
          configValue: smstemplate.text.$model.trim(),
        },
      };

      let mutation = ` mutation saveuserconfig($userConfig: SaveUserConfig!) {
	      saveuserconfig(userConfig: $userConfig) {
          id
          }
        }`;
      axios
        .post('/graphql', {
          query: mutation,
          variables: userConfig,
        })
        .then((res) => {
          if (res.data.data.saveuserconfig) {
            smstemplate.$reset();
            this.showSuccess('Template saved!');
          }
        })
        .catch(() => {
          this.showError('Could not save the template');
        });
    },
  },
};
</script>

<style></style>
